import {
  Alert,
  Box,
  Button,
  Card,
  FormControl,
  MenuItem,
  Pagination,
  Select,
  Snackbar,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  CircularProgress,
  Typography,
  Paper
} from '@mui/material';
import React, { useEffect, useState } from 'react';
import { styled } from '@mui/material/styles';
import { makeStyles } from '@mui/styles';
import PersonAddAltOutlinedIcon from '@mui/icons-material/PersonAddAltOutlined';
import moment from 'moment';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import ConfirmAlertDialog from './ConfirmDialog';
import AddNewOrganization from './_dashboard/smartlock/AddNewOrganization';
import { HeaderHeight, PageHeaderHeight } from '../Constants';
import OrganizationMoreMenu from './_dashboard/smartlock/OrganizationMoreMenu';
import AddNewAdmin from './_dashboard/smartlock/AddNewAdmin';
import OrganizationDeviceAssignModal from './_dashboard/smartlock/OrganizationDeviceAssignModal';
import NoDataAvailable from './_dashboard/smartlock/NoDataAvailable';
import { GetAllOrganization, UpdateOrganizationStatus } from '../network/Organization';

const useStyles = makeStyles((theme) => ({
  menuItem: {
    fontSize: '14px',
    [theme.breakpoints.down('sm')]: {
      fontSize: '12px'
    },
    minHeight: '20px',
    borderRadius: '8px',
    marginInline: theme.spacing(1)
  },
  tableCellStyle: {
    fontSize: {
      xs: '12px',
      md: '14px'
    },
    fontWeight: 700,
    padding: {
      xs: '8px',
      md: '16px'
    },
    textWrap: 'nowrap',
    backgroundColor: '#FFFFFF'
  },
  tablePaper: {
    width: '100%',
    height: '100%',
    overflow: 'hidden',
    backgroundColor: '#FFFFFF'
  },
  tableContainer: {
    flexGrow: 1,
    height: `calc(100vh - ${HeaderHeight + PageHeaderHeight + 56 + 40 + 50 + 18}px)`,
    overflow: 'auto'
  }
}));

const LoaderContainer = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  height: '50px'
});

const PageHeader = styled('Box')(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  gap: 1,
  flexDirection: 'row !important',
  height: PageHeaderHeight
}));

export default function OrganizationMangement() {
  const classes = useStyles();
  const [organizationList, setOrganizationList] = useState([]);
  const [page, setPage] = useState(1);
  const [sortFilterValue, setSortFilterValue] = useState(['created', 'DESC']);
  const [isAssignAddModal, setIsAssignAddModal] = useState(false);
  const [isAdminAssignModal, setIsAdminAssignModal] = useState(false);
  const [isDeviceAssignModal, setIsDeviceAssignModal] = useState(false);
  const [openConfirmAlertDialog, setOpenConfirmAlertDialog] = useState(false);
  const [orgDetails, setOrgDetails] = useState({});
  const [loader, setLoader] = useState(false);
  const [isStatusActive, setIsStatusActive] = useState(true);
  const [confirmAlertDialogMetas, setConfirmAlertDialogMetas] = useState({
    message: '',
    title: '',
    positiveBtnLable: '',
    negativeBtnLabel: ''
  });
  const [alertMetas, setAlertMetas] = useState({
    snackBarOpened: false,
    msg: '',
    variant: 'filled',
    severity: ''
  });

  const handleSnackBarClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setAlertMetas({ ...alertMetas, snackBarOpened: false });
  };

  const handleFilterChange = (e) => {
    const value = e.target.value.split(',');
    setSortFilterValue(value);
  };

  const handlePageChange = (event, value) => {
    setPage(value);
  };

  const handleUserMoreMenuClick = (action, data, status) => {
    switch (action) {
      case 'create_admin': {
        setOrgDetails(data);
        setIsAdminAssignModal(true);
        break;
      }
      case 'device_assign': {
        setOrgDetails(data);
        setIsDeviceAssignModal(true);
        break;
      }
      case 'edit_organization': {
        setOrgDetails(data);
        setIsAssignAddModal(true);
        break;
      }
      case 'organization_status': {
        setOrgDetails(data);
        setIsStatusActive(!status);
        setConfirmAlertDialogMetas({
          ...confirmAlertDialogMetas,
          message: `Are you sure want to ${status ? 'Deactivate' : 'Activate'} this organization ?`,
          title: ` ${status ? 'Deactivate' : 'Activate'} Organization`,
          positiveBtnLable: 'Confirm',
          negativeBtnLabel: 'Cancel'
        });
        setOpenConfirmAlertDialog(true);
        break;
      }
      default:
        return '';
    }
  };

  const organizationStatus = async (id, isStatusActive) => {
    try {
      const res = await UpdateOrganizationStatus(id, isStatusActive);
      if (res) {
        setAlertMetas({
          severity: 'success',
          snackBarOpened: true,
          msg: res?.data?.data
        });
        setTimeout(() => setAlertMetas({ ...alertMetas, snackBarOpened: false, msg: '' }), 4000);
        onAddOrganizationModalAction();
      }
    } catch (error) {
      setAlertMetas({
        severity: 'error',
        snackBarOpened: true,
        msg: error?.response?.data?.message
      });
      setTimeout(() => setAlertMetas({ ...alertMetas, snackBarOpened: false, msg: '' }), 4000);
    }
  };

  const getAllOrganization = async (page, sortFilterValue) => {
    setLoader(true);
    try {
      const res = await GetAllOrganization(page, sortFilterValue);
      if (res) {
        setLoader(false);
        setOrganizationList(res?.data);
      }
    } catch (error) {
      setLoader(false);
      console.log(error, 'err');
    }
  };

  const onAddOrganizationModalAction = () => {
    getAllOrganization(page, sortFilterValue);
  };

  useEffect(() => {
    getAllOrganization(page, sortFilterValue);
  }, [page, sortFilterValue]);

  return (
    <Box sx={{ width: '100%', typography: 'body1' }}>
      <Snackbar
        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
        open={alertMetas?.snackBarOpened}
        onClose={handleSnackBarClose}
        autoHideDuration={6000}
      >
        <Alert
          onClose={handleSnackBarClose}
          variant={alertMetas?.variant}
          severity={alertMetas?.severity}
        >
          {alertMetas?.msg}
        </Alert>
      </Snackbar>
      <Card sx={{ width: '100%', padding: '10px' }}>
        <Box>
          <PageHeader>
            <Stack direction="row" spacing={2} alignItems="center" justifyContent="space-between">
              <Button
                variant="outlined"
                size="medium"
                endIcon={<PersonAddAltOutlinedIcon />}
                onClick={() => setIsAssignAddModal(true)}
                sx={{ backgroundColor: '#FFFFFF' }}
              >
                Add
              </Button>
            </Stack>

            <FormControl size="small" sx={{ minWidth: { xs: 130, sm: 150 } }}>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                <Typography sx={{ fontSize: { xs: '12px', sm: '14px' }, fontWeight: 600 }}>
                  Sort By
                </Typography>
                <Select
                  sx={{
                    fontSize: { xs: '12px', sm: '14px' },
                    fontWeight: '500',
                    minWidth: '130px',
                    borderRadius: '12px'
                  }}
                  labelId="role-filter-select-label"
                  id="role-filter-select"
                  value={sortFilterValue.join(',')}
                  onChange={handleFilterChange}
                  IconComponent={ExpandMoreIcon}
                  MenuProps={{
                    PaperProps: {
                      style: {
                        maxHeight: 180,
                        overflowY: 'auto'
                      }
                    }
                  }}
                >
                  <MenuItem className={classes.menuItem} value="created,DESC">
                    Most Recent
                  </MenuItem>
                  <MenuItem className={classes.menuItem} value="created,ASC">
                    Oldest
                  </MenuItem>
                  <MenuItem className={classes.menuItem} value="name,ASC">
                    <Box
                      sx={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        width: '100%'
                      }}
                    >
                      <Typography sx={{ fontSize: { xs: '12px', sm: '14px' }, fontWeight: 500 }}>
                        Organization Name
                      </Typography>{' '}
                      <ExpandMoreIcon />
                    </Box>
                  </MenuItem>
                  <MenuItem className={classes.menuItem} value="name,DESC">
                    <Box
                      sx={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        width: '100%'
                      }}
                    >
                      <Typography sx={{ fontSize: { xs: '12px', sm: '14px' }, fontWeight: 500 }}>
                        Organization Name
                      </Typography>{' '}
                      <ExpandLessIcon />
                    </Box>
                  </MenuItem>
                  {/* {filterData.map((item) => (
                  <MenuItem value={item?.role} key={item?.id} sx={{ p: 1.5 }}>
                    {item?.role}
                  </MenuItem>
                ))} */}
                </Select>
              </Box>
            </FormControl>
          </PageHeader>
          <Box sx={{ width: '100%', typography: 'body1', borderTop: '1px solid #EBEBEB' }}>
            <Paper className={classes.tablePaper}>
              <TableContainer className={classes.tableContainer}>
                <Table stickyHeader aria-label="sticky table">
                  <TableHead>
                    <TableRow>
                      <TableCell className={classes.tableCellStyle} width={100}>
                        Name
                      </TableCell>
                      <TableCell className={classes.tableCellStyle} width={100}>
                        Date Created
                      </TableCell>
                      <TableCell className={classes.tableCellStyle} width={100}>
                        E-mail
                      </TableCell>
                      <TableCell className={classes.tableCellStyle} width={100}>
                        Phone Number
                      </TableCell>
                      <TableCell className={classes.tableCellStyle} width={100}>
                        Address
                      </TableCell>
                      <TableCell className={classes.tableCellStyle} width={100} />
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {loader && (
                      <TableRow>
                        <TableCell colSpan={10}>
                          <LoaderContainer>
                            <CircularProgress size={30} />
                          </LoaderContainer>
                        </TableCell>
                      </TableRow>
                    )}
                    {organizationList?.data?.length === 0 ? (
                      <TableRow>
                        <TableCell colSpan={10}>
                          <NoDataAvailable />
                        </TableCell>
                      </TableRow>
                    ) : (
                      organizationList?.data?.map((item) => (
                        <TableRow key={item?.id}>
                          <TableCell
                            align="left"
                            sx={{
                              textTransform: 'capitalize',
                              minWidth: '5vw',
                              textWrap: 'nowrap',
                              padding: {
                                xs: '8px',
                                md: '16px'
                              },
                              fontSize: {
                                xs: '12px',
                                md: '14px' // Larger screens
                              }
                            }}
                          >
                            {item?.name}
                          </TableCell>
                          <TableCell
                            sx={{
                              minWidth: '5vw',
                              textWrap: 'nowrap',
                              textTransform: 'capitalize',
                              padding: {
                                xs: '8px',
                                md: '16px'
                              },
                              fontSize: {
                                xs: '12px',
                                md: '14px' // Larger screens
                              }
                            }}
                            align="left"
                          >
                            {moment(item.createdAt).format('DD/MM/YYYY')}
                          </TableCell>
                          <TableCell
                            sx={{
                              minWidth: '5vw',
                              textWrap: 'nowrap',
                              padding: {
                                xs: '8px',
                                md: '16px'
                              },
                              fontSize: {
                                xs: '12px',
                                md: '14px' // Larger screens
                              }
                            }}
                            align="left"
                          >
                            {item?.email}
                          </TableCell>
                          <TableCell
                            sx={{
                              minWidth: '5vw',
                              textWrap: 'nowrap',
                              padding: {
                                xs: '8px',
                                md: '16px'
                              },
                              fontSize: {
                                xs: '12px',
                                md: '14px' // Larger screens
                              }
                            }}
                            align="left"
                          >
                            {item?.phone}
                          </TableCell>
                          <TableCell
                            align="left"
                            sx={{
                              textTransform: 'capitalize',
                              minWidth: '5vw',
                              textWrap: 'nowrap',
                              padding: {
                                xs: '8px',
                                md: '16px'
                              },
                              fontSize: {
                                xs: '12px',
                                md: '14px' // Larger screens
                              }
                            }}
                          >
                            {item?.address}
                          </TableCell>
                          <TableCell
                            sx={{
                              minWidth: '5vw',
                              textWrap: 'nowrap',
                              textTransform: 'capitalize',
                              padding: {
                                xs: '8px',
                                md: '16px'
                              },
                              fontSize: {
                                xs: '12px',
                                md: '14px' // Larger screens
                              }
                            }}
                            align="right"
                          >
                            <OrganizationMoreMenu
                              data={item.isActive}
                              handleClicks={(e) => handleUserMoreMenuClick(e, item, item?.isActive)}
                            />
                          </TableCell>
                        </TableRow>
                      ))
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
            </Paper>

            {organizationList?.data?.length !== 0 && (
              <Stack
                sx={{
                  marginTop: '10px',
                  marginBottom: '10px'
                }}
              >
                <Pagination
                  style={{ display: 'flex', justifyContent: 'flex-end' }}
                  count={organizationList?.totalPages}
                  showFirstButton
                  showLastButton
                  onChange={handlePageChange}
                  page={page}
                  total={organizationList?.total}
                />
              </Stack>
            )}
          </Box>
        </Box>
      </Card>
      {isAssignAddModal && (
        <AddNewOrganization
          openAssignedModal={isAssignAddModal}
          handleClose={() => setIsAssignAddModal(false)}
          data={orgDetails}
          onAction={() => onAddOrganizationModalAction()}
          setAlertMetas={setAlertMetas}
          alertMetas={alertMetas}
        />
      )}
      {isAdminAssignModal && (
        <AddNewAdmin
          openAssignedModal={isAdminAssignModal}
          handleClose={() => setIsAdminAssignModal(false)}
          orgData={orgDetails}
          setAlertMetas={setAlertMetas}
          alertMetas={alertMetas}
        />
      )}
      {isDeviceAssignModal && (
        <OrganizationDeviceAssignModal
          openAssignedModal={isDeviceAssignModal}
          handleClose={() => setIsDeviceAssignModal(false)}
          orgData={orgDetails}
        />
      )}
      <ConfirmAlertDialog
        openConfirmAlertDialog={openConfirmAlertDialog}
        message={confirmAlertDialogMetas?.message}
        title={confirmAlertDialogMetas?.title}
        positiveBtnLable={confirmAlertDialogMetas?.positiveBtnLable}
        negativeBtnLable={confirmAlertDialogMetas?.negativeBtnLabel}
        handleClose={() => setOpenConfirmAlertDialog(false)}
        handlePositiveClose={() => {
          organizationStatus(orgDetails?.id, isStatusActive);
          setOpenConfirmAlertDialog(false);
        }}
        handleNegativeClose={() => setOpenConfirmAlertDialog(false)}
      />
    </Box>
  );
}
